import React from "react";
import { number, bool, string } from "prop-types";

import Icon from "../icon";

const Messanger = ({ width = 28, height = 28, isShareRequired, text }) => (
  <Icon type="messanger" isShareRequired={isShareRequired} text={text}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width={width} height={height}>
      <g transform="translate(.019 -.011)">
        <path d="M0 0h28v28H0z" fill="rgba(255,255,255,0)" transform="translate(-.019 .011)" />
        <g transform="translate(3.991 4.014)">
          <path
            d="M24.867 11.5A9.523 9.523 0 0 0 15 21.071a9.364 9.364 0 0 0 3.1 7.08.8.8 0 0 1 .266.562l.054 1.755a.791.791 0 0 0 1.108.7l1.958-.864a.787.787 0 0 1 .526-.04 10.732 10.732 0 0 0 2.857.379 9.576 9.576 0 1 0 0-19.142z"
            fill="#fff"
            fillRule="evenodd"
            transform="translate(-15 -11.5)"
          />
          <path
            d="M209.805 351.82l2.9-4.6a1.481 1.481 0 0 1 2.14-.4l2.3 1.729a.593.593 0 0 0 .713 0l3.113-2.363a.468.468 0 0 1 .679.623l-2.9 4.6a1.481 1.481 0 0 1-2.14.4l-2.3-1.729a.593.593 0 0 0-.713 0l-3.115 2.364a.468.468 0 0 1-.677-.624z"
            fill="#448aff"
            transform="translate(-205.862 -339.449)"
          />
        </g>
      </g>
    </svg>
  </Icon>
);

Messanger.propTypes = {
  width: number,
  height: number,
  isShareRequired: bool,
  text: string,
};

export default Messanger;
